module.exports = __webpack_public_path__ + "img/00021.1143ca95.webp";